/**
 * @generated SignedSource<<f3e1eb33224f5327ff819c3b6ede8592>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type frequentlyAskedQuestionScreen_Query$variables = {};
export type frequentlyAskedQuestionScreen_Query$data = {
  readonly FrequentlyAskedQuestion: {
    readonly AllFrequentlyAskedQuestions: ReadonlyArray<{
      readonly answer: string;
      readonly id: string;
      readonly question: string;
      readonly sortIndex: number;
    }>;
  };
};
export type frequentlyAskedQuestionScreen_Query = {
  response: frequentlyAskedQuestionScreen_Query$data;
  variables: frequentlyAskedQuestionScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FrequentlyAskedQuestionQueries",
    "kind": "LinkedField",
    "name": "FrequentlyAskedQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FrequentlyAskedQuestion",
        "kind": "LinkedField",
        "name": "AllFrequentlyAskedQuestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortIndex",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "frequentlyAskedQuestionScreen_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "frequentlyAskedQuestionScreen_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6ddf70a1693c62531a393cfde988de3b",
    "id": null,
    "metadata": {},
    "name": "frequentlyAskedQuestionScreen_Query",
    "operationKind": "query",
    "text": "query frequentlyAskedQuestionScreen_Query {\n  FrequentlyAskedQuestion {\n    AllFrequentlyAskedQuestions {\n      id\n      answer\n      question\n      sortIndex\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e3c6e256bb11ce3652dce15009dcb4d";

export default node;
